import { render, staticRenderFns } from "./CertifyDocumentFirmaDialogComponent.vue?vue&type=template&id=48a809ad&scoped=true&lang=pug"
import script from "./CertifyDocumentFirmaDialogComponent.vue?vue&type=script&lang=ts"
export * from "./CertifyDocumentFirmaDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./CertifyDocumentFirmaDialogComponent.vue?vue&type=style&index=0&id=48a809ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a809ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a809ad')) {
      api.createRecord('48a809ad', component.options)
    } else {
      api.reload('48a809ad', component.options)
    }
    module.hot.accept("./CertifyDocumentFirmaDialogComponent.vue?vue&type=template&id=48a809ad&scoped=true&lang=pug", function () {
      api.rerender('48a809ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/firma/CertifyDocumentFirmaDialogComponent.vue"
export default component.exports